import React, { useState, useEffect, useCallback } from 'react';
import {
  Button,
  CardAvatar,
  CardHeader,
  VerticalSpace,
} from '@brokerbay/design-components';
import { MailFilled } from '@ant-design/icons';
import { OnboardingController } from 'api';
import { OnboardingAgentVerificationWrapper } from '../../../components/OnboardingAgentVerificationWrapper';
import { useUserOnboardingContext } from '../../../contexts/UserOnboardingContext';
import { useOrgOnboardingContext } from '../../../contexts/OrgOnboardingContext';

interface VerifyUnlicensedViewProps {
  handleGoBackStep: () => void;
}

const VerifyUnlicensedView = ({
  handleGoBackStep,
}: VerifyUnlicensedViewProps) => {
  const [working, setWorking] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const { userProfile } = useUserOnboardingContext();
  const { orgClaimHash } = useOrgOnboardingContext();

  const sendEmail = useCallback(async () => {
    const { email, id } = userProfile;
    setWorking(true);
    await OnboardingController.initiateSubmitterVerification(
      {
        email,
        ...(id && { userId: id }),
      },
      orgClaimHash,
    );
    if (!emailSent) setEmailSent(true);
    setWorking(false);
  }, [userProfile, orgClaimHash, emailSent]);

  useEffect(() => {
    if (userProfile && !emailSent && !working) {
      sendEmail();
    }
  }, [userProfile, emailSent, sendEmail, working]);

  return (
    <VerticalSpace>
      <CardHeader
        title={'Check your email'}
        icon={<CardAvatar icon={MailFilled} />}
        onRequestStepBack={handleGoBackStep}
      />

      <OnboardingAgentVerificationWrapper
        email={userProfile?.email}
        pageState="verificationSent"
      >
        <Button
          block
          type="primary"
          onClick={sendEmail}
          disabled={working}
          loading={working}
        >
          Resend Verification
        </Button>
      </OnboardingAgentVerificationWrapper>
    </VerticalSpace>
  );
};

export default VerifyUnlicensedView;
